import { VehicleValuationStatus } from "@/api-schema-enums";

export function canVehicleValuationSelectVehicle(
  status: VehicleValuationStatus | undefined,
  permissions: { canCreate: boolean; canManage: boolean },
): boolean {
  switch (status) {
    case VehicleValuationStatus.VehicleSelectionRequired:
      return permissions.canCreate || permissions.canManage;
    case VehicleValuationStatus.WaitingForConfirmation:
    case VehicleValuationStatus.OverhaulNeeded:
    case VehicleValuationStatus.Failed:
      return permissions.canManage;
    default:
      return false;
  }
}
